import React from "react";
import { Link } from "react-router-dom";
import DentalChair from "./images/about/chair.jpeg";
import CAAK from "./images/insurance/caak.jpeg";
import CIC from "./images/insurance/cic.jpeg";
import FirstAssurance from "./images/insurance/FirstAssurance.png";
import Kengen from "./images/insurance/kengen.jpeg";
import Madison from "./images/insurance/madison.jpeg";
// import NHIF from "./images/insurance/nhif.jpeg";
import OurTeam from "./OurTeam";
import Services from "./Services";

const CONTACT_EMAIL = "yayadentalclinic@gmail.com";

const BOOK_HREF = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
  "Appointment request"
)}`;

// Insurance providers accepted at the clinic, shown in the "We accept" strip.
const INSURERS = [
  { name: "CAAK", logo: CAAK },
  { name: "CIC Insurance", logo: CIC },
  { name: "First Assurance", logo: FirstAssurance },
  { name: "KenGen", logo: Kengen },
  { name: "Madison Insurance", logo: Madison },
  // { name: "NHIF", logo: NHIF },
];

const FEATURES = [
  {
    icon: "fa-user-doctor",
    text: "Skilled, experienced dentists and friendly staff",
  },
  {
    icon: "fa-heart",
    text: "Comfortable, welcoming, and stress-free visits",
  },
  {
    icon: "fa-teeth-open",
    text: "From routine check-ups and cleanings to advanced treatments and cosmetic dentistry",
  },
];

const CSS = `
@import url("https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&family=Young+Serif&display=swap");

.lp {
  --lp-ink: #10303a;
  --lp-body: #3f5a62;
  --lp-teal: #0d7a85;
  --lp-teal-dark: #0a5f68;
  --lp-mist: #eaf4f3;
  --lp-line: #d3e5e4;
  font-family: "Figtree", system-ui, -apple-system, "Segoe UI", sans-serif;
  color: var(--lp-body);
}
.lp *, .lp *::before, .lp *::after { box-sizing: border-box; }
.lp-wrap { max-width: 72rem; margin: 0 auto; }

.lp-title {
  font-family: "Young Serif", Georgia, serif;
  font-weight: 400;
  color: var(--lp-ink);
  font-size: clamp(1.9rem, 1.2rem + 3.2vw, 3.1rem);
  line-height: 1.1;
  letter-spacing: -0.01em;
  margin: 0;
  text-wrap: balance;
}

/* Buttons */
.lp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  min-height: 3rem;
  padding: 0.75rem 1.6rem;
  border-radius: 999px;
  font: inherit;
  font-weight: 600;
  text-decoration: none;
  border: 1.5px solid transparent;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  cursor: pointer;
}
.lp-btn-solid { background: var(--lp-teal); color: #fff; }
.lp-btn-solid:hover { background: var(--lp-teal-dark); color: #fff; }
.lp-btn-light { background: #fff; color: var(--lp-teal-dark); }
.lp-btn-light:hover { background: var(--lp-mist); color: var(--lp-teal-dark); }
.lp-btn-ghost { color: #fff; border-color: rgba(255, 255, 255, 0.75); background: transparent; }
.lp-btn-ghost:hover { background: rgba(255, 255, 255, 0.14); color: #fff; }
.lp :is(.lp-btn):focus-visible { outline: 3px solid #f0b429; outline-offset: 3px; }

/* Hero */
.lp-hero {
  position: relative;
  display: grid;
  align-items: center;
  /* Full screen at every size. min-height (not height) lets content grow
     past the viewport on short landscape phones instead of being clipped.
     100vh is the fallback; svh excludes mobile browser bars so the hero
     never hides behind them. */
  min-height: 100vh;
  min-height: 100svh;
  padding: clamp(5.5rem, 12vw, 8rem) clamp(1rem, 4vw, 2.5rem) clamp(3rem, 8vw, 6rem);
  overflow: hidden;
  background: #0a2f36;
}
.lp-hero-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center; }
.lp-hero-shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(8, 38, 46, 0.78) 0%, rgba(8, 38, 46, 0.62) 55%, rgba(8, 38, 46, 0.82) 100%);
}
@media (min-width: 62rem) {
  .lp-hero-shade { background: linear-gradient(90deg, rgba(8, 38, 46, 0.88) 0%, rgba(8, 38, 46, 0.6) 55%, rgba(8, 38, 46, 0.25) 100%); }
}
.lp-hero-body { position: relative; width: 100%; max-width: 72rem; margin: 0 auto; text-align: center; color: #fff; }
.lp-hero-title {
  font-family: "Young Serif", Georgia, serif;
  font-weight: 400;
  font-size: clamp(2.4rem, 1.4rem + 5vw, 4.75rem);
  line-height: 1.04;
  letter-spacing: -0.015em;
  margin: 0 auto 1.25rem;
  max-width: 14ch;
  text-wrap: balance;
}
.lp-hero-text {
  margin: 0 auto 2rem;
  max-width: 38rem;
  font-size: clamp(1.02rem, 0.95rem + 0.4vw, 1.25rem);
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.9);
  text-wrap: pretty;
}
.lp-hero-actions { display: flex; flex-direction: column; gap: 0.85rem; align-items: stretch; max-width: 22rem; margin: 0 auto; }
@media (min-width: 36rem) { .lp-hero-actions { flex-direction: row; justify-content: center; max-width: none; } }
@media (min-width: 62rem) {
  .lp-hero-body { text-align: left; }
  .lp-hero-title, .lp-hero-text { margin-left: 0; margin-right: 0; }
  .lp-hero-title { max-width: 12ch; }
  .lp-hero-actions { justify-content: flex-start; margin: 0; }
}

/* About */
.lp-about { background: #fff; padding: clamp(3.5rem, 9vw, 7rem) clamp(1rem, 4vw, 2.5rem); }
.lp-about-grid { display: grid; gap: clamp(1.75rem, 5vw, 4rem); align-items: center; }
@media (min-width: 48rem) { .lp-about-grid { grid-template-columns: 5fr 6fr; } }
.lp-about-media { border-radius: 1.5rem; overflow: hidden; aspect-ratio: 4 / 3; background: var(--lp-mist); }
@media (min-width: 48rem) { .lp-about-media { aspect-ratio: 4 / 5; } }
.lp-about-media img { width: 100%; height: 100%; object-fit: cover; display: block; }
.lp-about-lead {
  font-family: "Young Serif", Georgia, serif;
  color: var(--lp-ink);
  font-size: clamp(1.3rem, 1.05rem + 1.1vw, 1.8rem);
  line-height: 1.3;
  margin: 1rem 0 1rem;
  text-wrap: balance;
}
.lp-about-text { margin: 0 0 1.5rem; line-height: 1.7; max-width: 60ch; text-wrap: pretty; }
.lp-features { list-style: none; margin: 0 0 2rem; padding: 0; display: grid; gap: 0.9rem; }
.lp-features li { display: flex; gap: 0.9rem; align-items: flex-start; line-height: 1.5; }
.lp-feature-icon {
  flex: none;
  width: 2.5rem;
  height: 2.5rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--lp-mist);
  color: var(--lp-teal-dark);
}
.lp-features span:last-child { padding-top: 0.4rem; }
.lp-about .lp-title { text-align: center; }
@media (min-width: 48rem) { .lp-about .lp-title { text-align: left; } }

/* Insurance */
.lp-ins { background: #fff; padding: clamp(3rem, 8vw, 6rem) clamp(1rem, 4vw, 2.5rem); }
.lp-ins-head { text-align: center; max-width: 40rem; margin: 0 auto clamp(1.75rem, 4vw, 2.75rem); }
.lp-ins-sub { margin: 1rem 0 0; line-height: 1.65; }
.lp-ins-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: clamp(0.75rem, 2vw, 1.25rem);
}
.lp-ins-item {
  flex: 0 1 11rem;
  min-width: 8.5rem;
  height: 6.5rem;
  display: grid;
  place-items: center;
  padding: 0.9rem 1.1rem;
  background: #fff;
  border: 1px solid var(--lp-line);
  border-radius: 1rem;
  transition: border-color 0.2s ease;
}
.lp-ins-item:hover { border-color: var(--lp-teal); }
.lp-ins-item img { max-width: 100%; max-height: 100%; object-fit: contain; display: block; }
@media (max-width: 30rem) {
  .lp-ins-item { flex: 1 1 calc(50% - 0.75rem); min-width: 0; height: 5.5rem; }
}

@media (prefers-reduced-motion: reduce) {
  .lp-btn, .lp-ins-item { transition: none; }
}
`;

export default function LandingPage() {
  return (
    <div className="lp">
      <style>{CSS}</style>

      {/* Hero */}
      <header className="lp-hero">
        <img
          src={DentalChair}
          className="lp-hero-img"
          alt="Inside Yaya Dental Clinic"
          fetchpriority="high"
        />
        <div className="lp-hero-shade" aria-hidden="true"></div>
        <div className="lp-hero-body">
          <h1 className="lp-hero-title">Your smile, our priority</h1>
          <p className="lp-hero-text">
            Top-quality dental care in a comfortable and welcoming environment,
            from routine check-ups and cleanings to advanced treatments and
            cosmetic dentistry.
          </p>
          <div className="lp-hero-actions">
            <a className="lp-btn lp-btn-light" href={BOOK_HREF}>
              <i className="fa-regular fa-calendar-check" aria-hidden="true"></i>
              Book appointment
            </a>
            <Link className="lp-btn lp-btn-ghost" to="/services">
              Explore our services
              <i className="fa-solid fa-angle-right" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </header>

      {/* About */}
      <section className="lp-about" aria-labelledby="lp-about-title">
        <div className="lp-wrap lp-about-grid">
          <div className="lp-about-media">
            <img
              src={DentalChair}
              alt="Treatment room at Yaya Dental Clinic"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div>
            <h2 id="lp-about-title" className="lp-title">
              Welcome to our dental practice
            </h2>
            <p className="lp-about-lead">
              We prioritize your oral
              health and create beautiful smiles.
            </p>
            <p className="lp-about-text">
              With a team of skilled dentists and friendly staff, we provide
              top-quality dental care in a comfortable and welcoming
              environment. Our commitment to patient satisfaction and
              personalized care ensures that each visit is a positive and
              stress-free experience.
            </p>
            <ul className="lp-features">
              {FEATURES.map((f) => (
                <li key={f.icon}>
                  <span className="lp-feature-icon" aria-hidden="true">
                    <i className={`fa-solid ${f.icon}`}></i>
                  </span>
                  <span>{f.text}</span>
                </li>
              ))}
            </ul>
            <a className="lp-btn lp-btn-solid" href={BOOK_HREF}>
              <i className="fa-regular fa-calendar-check" aria-hidden="true"></i>
              Book appointment
            </a>
          </div>
        </div>
      </section>

      <Services />

      {/* Insurance */}
      <section className="lp-ins" aria-labelledby="lp-ins-title">
        <div className="lp-wrap">
          <div className="lp-ins-head">
            <h2 id="lp-ins-title" className="lp-title">
              Supported medical cover
            </h2>
            {/* <p className="lp-ins-sub">
              We work with these insurance providers, so you can focus on your
              treatment instead of the paperwork.
            </p> */}
          </div>
          <ul className="lp-ins-grid">
            {INSURERS.map((insurer) => (
              <li className="lp-ins-item" key={insurer.name}>
                <img
                  src={insurer.logo}
                  alt={insurer.name}
                  title={insurer.name}
                  loading="lazy"
                  decoding="async"
                />
              </li>
            ))}
          </ul>
        </div>
      </section>

      <OurTeam />
    </div>
  );
}